import { atom } from "recoil"

export const AtomUsersUrl = atom({
    key:'ATOMUSERSURL',
    default:''
})
  